export default {
  set_bays(state, { bays }) {
    state.bays = bays;
  },
  set_loading(state) {
    state.loading = true;
  },

};
